<script>
export default {
  props: {
    to: {
      type: String,
      default: () => ''
    },
    text: { type: String, required: true }
  },
  data() {
    return {
      isHovered: false
    }
  }
}
</script>

<template>
  <router-link :to="to">
    <r-button
      class="w-40 transition duration-300 text-lg font-sans"
      @mouseover="isHovered = true"
      @mouseleave="isHovered = false"
    >
      {{
        isHovered
          ? 'Купить билет'
          : `Билеты ${text.split(' ').splice(0, 2).join(' ')}₽`
      }}
    </r-button>
  </router-link>
</template>
